import { useIonRouter } from '@ionic/react';
import React, { useCallback, useState } from 'react';
import { t } from 'ttag';

import RoutePath from '@custom-types/RoutePath';
import { generateRoute } from '@services/navigation-service';

import List from './List';
import { useEvents } from './queries';
import { Event } from './service';

const EventList = () => {
  const [searchValue, setSearchValue] = useState('');
  const { push: pushRoute } = useIonRouter();

  const eventsQueryResult = useEvents(searchValue);

  const onClick = useCallback(
    (event: Event) => {
      pushRoute(generateRoute(RoutePath.EventDetail, { eventId: event.id }));
    },
    [pushRoute]
  );

  return (
    <List
      eventsQueryResult={eventsQueryResult}
      onSearch={setSearchValue}
      searchValue={searchValue}
      onSelectEvent={onClick}
      noEventMessage={
        !searchValue
          ? t`There are no happening or upcoming events with onsite features enabled.`
          : ''
      }
    />
  );
};

export default EventList;
